import styled from '@emotion/styled'
import { keyframes } from '@emotion/core'
import { ChecTable, CollapsibleWidget } from 'components/chec'

const snapshotModalSlideIn = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`

export const FullPageOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fbfbfb;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  animation: ${snapshotModalSlideIn} 300ms cubic-bezier(0.9, 0, 0.3, 0.7);
`

export const ModalPageContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 25px;
  padding: 25px;
`

export const SectionTabGroup = styled.div`
  display: flex;
  button:first-of-type {
    border-radius: 3px 0 0 3px;
  }
  button:not(:first-of-type) {
    margin-left: -1px;
    border-radius: 0;
  }
  button:last-of-type {
    border-radius: 0 3px 3px 0;
  }
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: rgba(7, 7, 15, 0.87);
  line-height: 24px;
`

export const SnapshotSelectorRow = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  flex-shrink: 0;
`

export const SnapshotSelectorTab = styled.button`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 5px 8px;
  height: 24px;
  border-radius: 3px;
  border: 1px solid ${({ active }) => (active ? 'transparent' : '#8c96a2')};
  background: ${({ active }) => (active ? 'rgba(0, 81, 196, 1)' : '#fff')};
  color: ${({ active, disabled }) =>
    disabled ? 'rgba(7, 7, 15, 0.4)' : active ? '#fff' : '#0b2e6b'};
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.1px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  white-space: nowrap;
  flex-shrink: 0;
  position: relative;
  z-index: ${({ active }) => (active ? 1 : 0)};
  ${({ active, disabled }) =>
    !active &&
    !disabled &&
    `&:hover { border-color: rgba(30, 122, 255, 1); color: rgba(30, 122, 255, 1); }`}
`

export const SnapshotHeader = styled.div`
  display: flex;
  align-items: center;
  height: 80px;
  padding: 10px 25px;
  background: #ffffff;
  border-bottom: 1px solid rgba(227, 229, 232, 1);
  flex-shrink: 0;
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: rgba(7, 7, 15, 0.87);
  line-height: 32px;
`

export const SectionTabRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-shrink: 0;
`

export const SectionTab = styled.button`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 8px 12px;
  height: 32px;
  border-radius: 3px;
  border: 1px solid
    ${({ active, disabled }) =>
      disabled ? '#d9d9d9' : active ? 'transparent' : '#8c96a2'};
  background: ${({ active, disabled }) =>
    disabled ? '#f5f5f5' : active ? 'rgba(0, 81, 196, 1)' : '#fff'};
  color: ${({ active, disabled }) =>
    disabled ? '#bfbfbf' : active ? '#fff' : '#0b2e6b'};
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  white-space: nowrap;
  flex-shrink: 0;
  position: relative;
  z-index: ${({ active }) => (active ? 1 : 0)};
  ${({ active, disabled }) =>
    !active && !disabled && `&:hover { color: rgba(30, 122, 255, 1); }`}
`

export const TabContentArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 25px;
`

export const SectionLabel = styled.h4`
  margin: 0 0 8px 0;
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: rgba(7, 7, 15, 0.7);
  line-height: 20px;
`

export const PtoDropdownRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 379px;
`

export const TableWrapper = styled.div`
  border: 1px solid rgba(227, 229, 232, 1);
  border-bottom: none;
  border-radius: 3px;
  margin-bottom: 24px;
  overflow-x: auto;
`

export const DataTable = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
`

export const DataTableHead = styled.thead`
  th {
    padding: 0 12px;
    height: 35px;
    vertical-align: middle;
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    color: rgba(7, 7, 15, 0.7);
    border-bottom: 1px solid rgba(227, 229, 232, 1);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: rgba(241, 242, 243, 1);
  }
`

export const DataTableBody = styled.tbody``

export const DataTableRow = styled.tr``

export const DataTableCell = styled.td`
  padding: 0 12px;
  font-weight: 300;
  color: rgba(7, 7, 15, 0.7);
  border-bottom: 1px solid rgba(227, 229, 232, 1);
  vertical-align: middle;
  line-height: 18px;
  height: 35px;
  overflow: hidden;
`

export const PneumaticsTableHead = styled(DataTableHead)`
  th {
    padding: 0 8px;
    font-weight: 700;
    border-right: 1px solid #ffffff;
  }
  th:last-child {
    border-right: none;
  }
`

export const PneumaticsTableCell = styled(DataTableCell)`
  padding: 0 8px;
  color: rgba(7, 7, 15, 0.7);
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const StyledSgChecTable = styled(ChecTable)`
  .ant-table {
    border: 1px solid rgba(227, 229, 232, 1);
  }
  .ant-table-small {
    border: 1px solid rgba(227, 229, 232, 1);
  }
  .chec-table-row > td {
    padding: 2px 8px !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid rgba(227, 229, 232, 1);
  }
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: transparent !important;
  }
  .chec-table td,
  .chec-table th {
    padding: 5px 8px !important;
  }
  .chec-table-row {
    height: 3px;
  }
  thead.ant-table-thead {
    background-color: rgba(241, 242, 243, 1);
    height: 3px;
    padding: 5px 8px !important;
  }
  th {
    border-right: 1px solid #ffffff !important;
    font-weight: 300 !important;
  }
  th:last-child {
    border-right: none !important;
  }
`

export const SgListHeader = styled.h3`
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  line-height: 1.33;
  margin: 0;
  padding-top: 10px;
`

export const SgSectionHeader = styled.div`
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: rgba(7, 7, 15, 0.7);
  line-height: 1.33;
  padding: 4px 0;
`

export const StyledSgCollapsibleWidget = styled(CollapsibleWidget)`
  && {
    border: 0px;

    .collapsible-widget_header {
      background-color: transparent;
      background: transparent;
      border: 0px;
      height: 16px;
    }
    .collapsible-widget_header > div {
      display: flex;
      flex-direction: row-reverse;
      align-items: baseline;
      justify-content: inherit;
      width: 950px;
    }
  }
`

export const StyledPneumaticsTable = styled(ChecTable)`
  margin-bottom: 24px;
  .ant-table {
    border: 1px solid rgba(227, 229, 232, 1);
  }
  .ant-table-small {
    border: 1px solid rgba(227, 229, 232, 1);
  }
  .chec-table-row > td {
    padding: 2px 8px !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid rgba(227, 229, 232, 1);
  }
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: transparent !important;
  }
  .chec-table td,
  .chec-table th {
    padding: 5px 8px !important;
  }
  thead.ant-table-thead {
    background-color: rgba(241, 242, 243, 1);
    height: 3px;
    padding: 5px 8px !important;
  }
  th {
    border-right: 1px solid #ffffff !important;
    font-weight: 300 !important;
  }
  th:last-child {
    border-right: none !important;
  }
`

export const EcpHeader = styled.div`
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: rgba(7, 7, 15, 0.87);
  padding: 6px 0 4px;
  margin-top: 8px;
`

export const PanelHeader = styled.div`
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: rgba(7, 7, 15, 0.87);
  padding: 8px 12px;
  background: rgba(241, 242, 243, 1);
  border-top: 1px solid rgba(227, 229, 232, 1);
  margin-top: 8px;

  &:first-of-type {
    border-top: none;
    margin-top: 0;
  }
`

export const SnapshotMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  font-family: Arial, sans-serif;
  font-size: 13px;
  color: rgba(7, 7, 15, 0.6);
  line-height: 18px;
`

export const FeatureCount = styled.div`
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: rgba(7, 7, 15, 0.4);
  margin-bottom: 12px;
`

export const FeatureTable = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
`

export const FeatureTableHead = styled.thead`
  th {
    padding: 6px 8px;
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    color: rgba(7, 7, 15, 0.7);
    border-bottom: 1px solid rgba(227, 229, 232, 1);
    border-right: 1px solid #ffffff;
    white-space: normal;
    background: #f1f2f3;
    min-height: 35px;
    vertical-align: middle;
  }
  th:last-child {
    border-right: none;
  }
`

export const FeatureTableBody = styled.tbody``

export const FeatureRow = styled.tr``

export const FeatureCell = styled.td`
  padding: 0 8px;
  font-weight: 300;
  color: rgba(7, 7, 15, 0.7);
  border-bottom: 1px solid rgba(227, 229, 232, 1);
  vertical-align: middle;
  line-height: 18px;
  height: 35px;
  overflow: hidden;
`

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
`

export const EmptyStateBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 45px 0;
  background: #f1f2f3;
  border: 1px solid #e3e5e8;
  border-radius: 3px;
  align-self: stretch;
`

export const EmptyState = styled.div`
  text-align: center;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: rgba(7, 7, 15, 0.4);
  line-height: 18px;
`

export const QpmSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: rgba(7, 7, 15, 0.7);
`

export const AsBuiltOriginBanner = styled.p`
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(7, 7, 15, 0.7);
  margin: 0;
`
